import React, { useEffect, useState } from "react";
import { auth } from "../../../utils/auth";
import { request } from "../../../utils/request";
import dayjs from "dayjs";
import Loader from "../../general/Loader";
import { formatCurrency } from "../../../utils/helpers";
import { calcAggregate, sumTotal } from "./functions";

const ReporteCuadreCajaVenta = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const [cuadre, setCuadre] = useState({});
    const [loading, setLoading] = useState(true);

    const getReporteData = async () => {
        setLoading(true);

        const url = `cuadre-caja/${id}`;
        const res = await request(url);
        setCuadre(res.data);
        setLoading(false);
    };

    useEffect(() => {
        getReporteData();
    }, []);

    // Espera a que loading pase a false, con los datos ya reflejados en el
    // DOM, antes de abrir el diálogo de impresión.
    useEffect(() => {
        if (!loading) {
            window.print();
        }
    }, [loading]);

    const recibos = cuadre.documentos?.filter((documento) => documento.tipo === "Recibo") ?? [];
    const facturas = cuadre.documentos?.filter((documento) => documento.tipo === "Factura") ?? [];
    const notasCreditos = cuadre.documentos?.filter((documento) => documento.tipo === "Nota de crédito") ?? [];

    const recibosTotal = sumTotal(recibos);
    const facturasTotal = sumTotal(facturas);
    const notasCreditosTotal = sumTotal(notasCreditos);

    const aggregate = calcAggregate(cuadre.documentos);

    return <>
        <style>{`@page {size: A4 portrait}`}</style>
        <div className="row">
            <h2 className="col-md-12 text-center m-b-5">
                Reporte Cuadre de Caja de Cobros
            </h2>

            <div className="col-md-12 text-center">
                {sucursal.nombre} •{" "}
                {dayjs(cuadre.created_at).format("DD/MM/YYYY")}
            </div>

            {!loading && <div className="col-md-12 text-center">
                <strong className="mr-1">{cuadre?.vendedor ? "Vendedor:"  : "Sin Vendedor"}</strong>
                {cuadre?.vendedor ? `${cuadre.vendedor.nombre} ${cuadre.vendedor.apellido}` : ""}
            </div>}
        </div>

        {loading && <Loader/> }

        {!loading && <>
            <div className="d-flex justify-content-center mt-4">
                <div className="row border" style={{fontSize:"0.9rem", width: "680px"}}>
                    <div className="col col-md-12">
                        <h3 className="pt-3 pb-3 text-center border-bottom">Ventas</h3>
                    </div>

                    <div className="col col-md-7 pb-3">
                        <div className="col-12">
                            <b style={{fontSize: "16px"}}>Total Facturado</b> = <span className="float-right">{formatCurrency(aggregate.total_facturado)}</span><br/>
                        </div>
                        <div className="col col-md-12 border-top pt-4">
                            <h5 className="my-1 text-center">INGRESOS</h5>
                            <b>Facturas</b> = <span className="float-right">{formatCurrency(aggregate.facturas)}</span><br/>
                            <b>Recibos</b> = <span className="float-right">{formatCurrency(aggregate.recibos)}</span><br/>
                            <div className="border-top"><b>Total Ingresos</b> = <span className="float-right">{formatCurrency(aggregate.facturas + aggregate.recibos)}</span></div><br/>
                        </div>
                        <div className="col col-md-12" style={{paddingTop: "1.3rem"}}>
                            <b>Ventas a crédito</b> = <span className="float-right">{formatCurrency(aggregate.credito)}</span><br/>
                            <b>Notas crédito</b> = <span className="float-right">{formatCurrency(aggregate.notaCreditos)}</span><br/>
                        </div>
                    </div>

                    <div className="col col-md-5">
                        <h5 className="py-2 text-center">FORMA DE PAGO</h5>
                        <b>Efectivo</b> = <span className="float-right">{formatCurrency(aggregate.efectivo)}</span><br/>
                        <b>Transferencia</b> = <span className="float-right">{formatCurrency(aggregate.transferencia)}</span><br/>
                        <b>Cheque</b> = <span className="float-right">{formatCurrency(aggregate.cheque)}</span><br/>
                        <b>Tarjeta</b> = <span className="float-right">{formatCurrency(aggregate.tarjeta)}</span><br/>
                        <b>Depósito</b> = <span className="float-right">{formatCurrency(aggregate.deposito)}</span><br/>
                        <b>Otro</b> = <span className="float-right">{formatCurrency(aggregate.otro)}</span><br/>
                    </div>

                    <div className="col col-md-7 pb-3">
                        <div className="col">
                            <h5 className="py-2 text-center">TÉRMINOS DE PAGO</h5>
                            <b>CONTADO</b> = <span className="float-right">{formatCurrency(aggregate.contado)}</span><br/>
                            <b>CRÉDITO</b> = <span className="float-right">{formatCurrency(aggregate.credito)}</span><br/>
                            <b>CONTRA ENTREGA</b> = <span className="float-right">{formatCurrency(aggregate.contra_entrega)}</span><br/>
                        </div>
                    </div>
                </div>
            </div>
        </>}
    </>;
};

export default ReporteCuadreCajaVenta;